import QUERY, {
	type FieldsPageContentQuery,
} from '@jira/project-settings__project-fields/src/__generated__/FieldsPageContentQuery.graphql';
import type { PreloadedQuery } from 'react-relay';
import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import { getProjectKeyId } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';

const RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS = 'PROJECT_SETTINGS_FIELDS';

export const fieldSettingsRelayResource: RouteResource<
	PreloadedQuery<FieldsPageContentQuery, Record<string, unknown>>
> = createRelayResource<FieldsPageContentQuery>({
	type: RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS,
	getQuery: ({ match, query }, { tenantContext }) => {
		const { projectKey } = getProjectKeyId(match, query);

		// Parse deep link parameters
		const fieldId = query.fieldId;
		const isValidSidebarId = ['EDIT'].includes(query.sidebarId?.toUpperCase());
		const shouldPreloadField = Boolean(isValidSidebarId && !!fieldId);

		return {
			parameters: QUERY,
			variables: {
				projectKey: projectKey ?? '',
				cloudId: tenantContext.cloudId ?? '',
				preloadedFieldId: fieldId ?? 'UNUSED_STRING',
				shouldPreloadField: shouldPreloadField ?? false,
			},
			options: { fetchPolicy: 'network-only' },
		};
	},
});
